import { useContext, useEffect, useState, type FC } from "react";
import MainLayout from "../components/MainLayout";
import { SearchContext } from "../contexts/SearchContext";
import { LoadingContext } from "../contexts/LoadingContext";
import { PaginationResponse } from "../objects/pagination";
import { StockMovement } from "../models/inventory/stock_movement";
import {
  createStockMovement,
  getStockMovements,
  updateStockMovement,
} from "../services/inventory/StockMovementApi";
import { getPagination } from "../utils/helper";
import { errorToast } from "../utils/helper-ui";
import { Button, Checkbox, IconButton, Pagination, Table } from "rsuite";
import PlusIcon from "@rsuite/icons/Plus";
import StockMovementForm from "../components/features/inventory/StockMovementForm";
import { useNavigate } from "react-router-dom";
import Moment from "react-moment";
const { Column, HeaderCell, Cell } = Table;
interface StockMovementPageProps {}

const StockMovementPage: FC<StockMovementPageProps> = ({}) => {
  const { search, setSearch } = useContext(SearchContext);
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const [mounted, setMounted] = useState(false);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(30);
  const [pagination, setPagination] = useState<PaginationResponse>();
  const [stockMovements, setStockMovements] = useState<StockMovement[]>([]);
  const [modalFormOpen, setModalFormOpen] = useState(false);
  const nav = useNavigate();
  const [selectedStockMovement, setSelectedStockMovement] =
    useState<StockMovement>();

  const [checkedKeys, setCheckedKeys] = useState<string[]>([]);
  let checked = false;
  let indeterminate = false;

  if (checkedKeys.length === stockMovements.length) {
    checked = true;
  } else if (checkedKeys.length === 0) {
    checked = false;
  } else if (checkedKeys.length > 0 && checkedKeys.length < stockMovements.length) {
    indeterminate = true;
  }

  const handleCheckAll = (
    value: any,
    checked: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const keys = checked ? stockMovements.map((item) => item.id) : [];
    setCheckedKeys(keys);
  };
  const handleCheck = (
    value: any,
    checked: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const keys = checked
      ? [...checkedKeys, value as string]
      : checkedKeys.filter((item) => item !== (value as string));
    setCheckedKeys(keys);
  };

  useEffect(() => {
    setMounted(true);

    return () => {
      setMounted(false);
    };
  }, []);

  useEffect(() => {
    if (!mounted) return;
    fetchData();
  }, [mounted, search, page, size]);

  const saveStockMovement = async (stockMovement: StockMovement) => {
    try {
      setIsLoading(true);
      if (selectedStockMovement) {
        await updateStockMovement(selectedStockMovement.id!, stockMovement);
      } else {
        await createStockMovement(stockMovement);
      }
      setModalFormOpen(false);
      setSelectedStockMovement(undefined);
      fetchData();
      setStockMovements([]);
    } catch (error) {
      errorToast(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };

  const renderHeader = () => (
    <div className="flex flex-row justify-between items-center px-2">
      <h1 className="text-2xl font-semibold">Stock Movement</h1>
      {/* button */}
      <div>
        <IconButton
          size="sm"
          appearance="primary"
          color="green"
          icon={<PlusIcon />}
          onClick={() => setModalFormOpen(true)}
        >
          Create Stock Movement
        </IconButton>
      </div>
    </div>
  );

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const res = await getStockMovements({ page, size, search });
      const resJson = await res.json();
      //   console.log(data);
      setStockMovements((prev) => [...prev, ...resJson.data.items]);
      setPagination(getPagination(resJson.data));
    } catch (error) {
      errorToast(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <MainLayout header={renderHeader()}>
       <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr>
              <th className="px-4 py-2 text-left border bg-gray-50">
                <Checkbox
                  inline
                  checked={checked}
                  indeterminate={indeterminate}
                  onChange={handleCheckAll}
                />
              </th>
              <th className="px-4 py-2 text-left border bg-gray-50">Date</th>
              <th className="px-4 py-2 text-left border bg-gray-50">
                Description
              </th>
              <th className="px-4 py-2 text-left border bg-gray-50">Product</th>
              <th className="px-4 py-2 text-left border bg-gray-50">
                Quantity
              </th>
              <th className="px-4 py-2 text-left border bg-gray-50">
                Merchant
              </th>
              <th className="px-4 py-2 text-left border bg-gray-50">
                Warehouse
              </th>
              <th className="px-4 py-2 text-left border bg-gray-50">Type</th>
            </tr>
          </thead>
          <tbody>
            {stockMovements.map((rowData, i) => (
              <tr key={rowData.id} style={{ borderBottom: "1px solid #ddd" }}>
                <td className="px-4 py-2 border">
                  <Checkbox
                    value={rowData.id}
                    inline
                    onChange={handleCheck}
                    checked={checkedKeys.some((item) => item === rowData.id)}
                  />
                  {i + 1}
                </td>

                <td className="px-4 py-2 border">
                  <Moment format="DD/MM/YYYY">{rowData.date}</Moment>
                </td>
                <td className="px-4 py-2 border">
                  <div
                    className="hover:underline cursor-pointer font-semibold"
                    onClick={() => {
                      // setSelectedStockMovement(rowData as StockMovement);
                      // setModalFormOpen(true);
                    }}
                  >
                    {rowData.description}
                  </div>
                </td>
                <td className="px-4 py-2 border">
                  {rowData.product ? (
                    <div
                      className="hover:underline cursor-pointer"
                      onClick={() => nav(`/product/${rowData.product?.id}`)}
                    >
                      {rowData.product?.name}
                    </div>
                  ) : (
                    "N/A"
                  )}
                </td>
                <td className="px-4 py-2 border" style={{ textAlign: "right" }}>
                  {rowData.quantity}
                </td>
                <td className="px-4 py-2 border">
                  <div
                    className="hover:underline cursor-pointer"
                    onClick={() => nav(`/merchant/${rowData.merchant?.id}`)}
                  >
                    {rowData.merchant?.name || "N/A"}
                  </div>
                </td>
                <td className="px-4 py-2 border">
                  {rowData.warehouse?.name || "N/A"}
                </td>
                <td className="px-4 py-2 border">{rowData.type}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {!pagination?.last && (
        <div className="flex justify-center my-2">
          <Button
            onClick={() => {
              setPage((pagination?.page ?? 0) + 1);
            }}
          >
            Load more
          </Button>
        </div>
      )}
      {/* <Table minHeight={700} data={stockMovements} onRowClick={(data, i) => {}}>
        <Column width={50} align="center" fixed>
          <HeaderCell style={{ padding: 0 }}>
            <div style={{ lineHeight: "40px" }}>
              <Checkbox
                inline
                checked={checked}
                indeterminate={indeterminate}
                onChange={handleCheckAll}
              />
            </div>
          </HeaderCell>
          <Cell style={{ padding: 0 }}>
            {(rowData) => (
              <div style={{ lineHeight: "46px" }}>
                <Checkbox
                  value={rowData.id}
                  inline
                  onChange={handleCheck}
                  checked={checkedKeys.some((item) => item === rowData.id)}
                />
              </div>
            )}
          </Cell>
        </Column>
        <Column width={70} align="center" fixed>
          <HeaderCell>No</HeaderCell>
          <Cell>
            {(rowData) => (
              <div>
                {(page - 1) * size +
                  stockMovements.indexOf(rowData as StockMovement) +
                  1}
              </div>
            )}
          </Cell>
        </Column>
        <Column width={100} resizable fixed>
          <HeaderCell>Date</HeaderCell>
          <Cell>
            {(rowData) => (
              <Moment format="DD/MM/YYYY">{rowData.date}</Moment >
            )}
          </Cell>
        </Column>

        <Column width={200} resizable fixed>
          <HeaderCell>Description</HeaderCell>
          <Cell>
            {(rowData) => (
              <div
                className="hover:underline cursor-pointer font-semibold "
                onClick={() => {
                //   setSelectedStockMovement(rowData as StockMovement);
                //   setModalFormOpen(true);
                }}
              >
                {rowData.description}
              </div>
            )}
          </Cell>
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Product</HeaderCell>
          <Cell>{(rowData) => rowData.product ? <div className="hover:underline cursor-pointer" onClick={() => nav(`/product/${rowData.product?.id}`)}> {rowData.product?.name} </div> : "N/A"}</Cell>
        </Column>
        <Column width={100} resizable align="right">
          <HeaderCell>Quantity</HeaderCell>
          <Cell dataKey="quantity" />
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Merchant</HeaderCell>
          <Cell>{(rowData) => <div className="hover:underline cursor-pointer" onClick={() => nav(`/merchant/${rowData.merchant?.id}`)}> {rowData.merchant?.name || "N/A"} </div>}</Cell>
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Warehouse</HeaderCell>
          <Cell>{(rowData) => rowData.warehouse?.name || "N/A"}</Cell>
        </Column>

        <Column width={120} resizable>
          <HeaderCell>Type</HeaderCell>
          <Cell dataKey="type" />
        </Column>
      </Table>
      <div style={{ padding: 20 }}>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="xs"
          layout={["total", "-", "limit", "|", "pager", "skip"]}
          total={pagination?.total ?? 0}
          limitOptions={[10, 30, 50]}
          limit={pagination?.size}
          activePage={pagination?.page}
          onChangePage={setPage}
          onChangeLimit={setSize}
        />
      </div> */}
      <StockMovementForm
        open={modalFormOpen}
        onClose={() => setModalFormOpen(false)}
        stockMovement={selectedStockMovement}
        onSubmit={(val) => {
          if (!val.warehouse_id) {
            errorToast("Warehouse is required");
            return;
          }
          if (!val.product_id) {
            errorToast("Product is required");
            return;
          }
          if (val.quantity == 0) {
            errorToast("Quantity cannot be 0");
            return;
          }
          saveStockMovement(val);
        }}
      />
    </MainLayout>
  );
};
export default StockMovementPage;
